import { axiosObject } from "../config";

export default function submitPYPData(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/posted_properties/_patch";
    axiosObject
      .post(uri, data)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
